export interface Integration {
  id: string | null;
  name: string;
  type: IntegrationType;
  integrationSlug?: string;
  metadata?: MetaDataType;
  status: string;
  feature?: string;
}
interface MetaDataType {
  orgName: string;
  email: string;
  orgId: string;
  country: string | null;
  shopDomain?: string;
}

export enum IntegrationStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export interface PermissionAPIResponse {
  usersData: {
    userId: string;
    username: string;
  }[];
}

export enum IntegrationType {
  QUICKSELL = 'Quicksell',
  WHATSAPP_CLOUD = 'Whatsapp Cloud Api',
  WHATSAPP_BUSINESS = 'Whatsapp Business Solution',
  OPENAI = 'OpenAI',
  ZOHO_CRM = 'ZOHO_CRM',
  TALLY = 'Tally',
}
export interface IntegrationDetails extends Integration {
  credentials: {
    apiKey?: string;
    appSecret?: string;
    channelId?: string;
    phoneName?: string;
    phoneNumber?: string;
    status?: string;
  };
}
